import type { IxmUserauthV1RealmAccessKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const USERAUTH_REALM_ACCESS_BASE_PATH = getResolvedPath('/realm-access');

export const getUserauthRealmAccessPath: EntityPathBuilder<IxmUserauthV1RealmAccessKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return USERAUTH_REALM_ACCESS_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.realmAccessId) {
        return undefined;
      }

      return getResolvedPath(`${USERAUTH_REALM_ACCESS_BASE_PATH}/$realmAccessId`, context.keys);
    }
  }
};

export function getUserauthRealmAccessDetailPath(realmAccessId: string | undefined) {
  if (!realmAccessId) {
    return undefined;
  }

  return getUserauthRealmAccessPath({ kind: 'detail', keys: { realmAccessId } });
}
